<template>
  <v-dialog
    :model-value="modelValue"
    max-width="560"
    persistent
    scrollable
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="pa-2">
      <v-card-title class="text-h6">
        {{ $t("acceptance.confirm.title") }}
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="blocking.length"
          type="error"
          variant="tonal"
          density="compact"
          class="mb-3"
        >
          {{ $t("acceptance.confirm.blocked_intro") }}
        </v-alert>
        <div v-else-if="warnings.length" class="text-body-2 mb-3">
          {{ $t("acceptance.confirm.warnings_intro") }}
        </div>
        <div v-else class="text-body-2 mb-3">
          {{ $t("acceptance.confirm.ready_intro") }}
        </div>

        <template v-if="blocking.length">
          <div class="text-body-2 font-weight-medium text-red-darken-2 mb-1">
            {{
              $t("acceptance.validation.blocking", { count: blocking.length })
            }}
          </div>
          <div
            v-for="item in blocking"
            :key="`b-${item.code}`"
            class="confirm-item d-flex align-start py-1"
          >
            <v-icon size="16" color="red-darken-2" class="mr-2 mt-1">
              mdi-alert-circle-outline
            </v-icon>
            <span class="text-body-2">{{ label(item) }}</span>
          </div>
        </template>

        <template v-if="warnings.length">
          <div
            class="text-body-2 font-weight-medium text-amber-darken-4 mb-1"
            :class="{ 'mt-3': blocking.length }"
          >
            {{
              $t("acceptance.validation.warnings", { count: warnings.length })
            }}
          </div>
          <div
            v-for="item in warnings"
            :key="`w-${item.code}`"
            class="confirm-item d-flex align-start py-1"
          >
            <v-icon size="16" color="amber-darken-4" class="mr-2 mt-1">
              mdi-alert-outline
            </v-icon>
            <span class="text-body-2">{{ label(item) }}</span>
          </div>
        </template>

        <div v-if="!blocking.length" class="text-body-2 mt-4">
          {{ $t("acceptance.confirm.freeze_notice") }}
        </div>

        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          density="compact"
          class="mt-3"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="outlined"
          color="primary"
          :disabled="saving"
          @click="$emit('update:modelValue', false)"
        >
          {{
            blocking.length
              ? $t("acceptance.confirm.back")
              : $t("acceptance.confirm.cancel")
          }}
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          :loading="saving"
          :disabled="blocking.length > 0 || saving"
          @click="$emit('confirm')"
        >
          {{
            warnings.length
              ? $t("acceptance.confirm.submit_anyway")
              : $t("acceptance.confirm.submit")
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationLabel } from "@/components/Acceptance/validationLabels.mjs";

export default {
  name: "AcceptanceConfirmDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    // GET / PATCH `validation`, or the details of a 422 confirm_blocked answer:
    // { blocking: [{ code, details? }], warnings: [...] }
    validation: { type: Object, default: null },
    // dossier.checklist, to name the lines still to answer
    lines: { type: Array, default: () => [] },
    saving: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue", "confirm"],
  computed: {
    blocking() {
      return (this.validation && this.validation.blocking) || [];
    },
    warnings() {
      return (this.validation && this.validation.warnings) || [];
    },
  },
  methods: {
    label(item) {
      return validationLabel(item, {
        t: (key, params) => this.$t(key, params),
        lines: this.lines,
      });
    },
  },
};
</script>

<style scoped>
.confirm-item + .confirm-item {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
